import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { FullscreenBreadcrumb, FullscreenButton } from '../_interfaces/fullscreen';
import { FullscreenService } from './fullscreen.service';

@Injectable({
  providedIn: 'root'
})
export class BreadcumbService {

  constructor(private fullscreenSrv: FullscreenService){}


  public isHidden: boolean = false
  
  private _buttons : FullscreenButton[] = [];
  public get buttons() : FullscreenButton[] {
    return this._buttons;
  }
  public set buttons(v : FullscreenButton[]) {
    this._buttons = v;
  }
  
  
  private _hideOnSmallDevices : boolean = true
  public get hideOnSmallDevices() : boolean {
    return this._hideOnSmallDevices;
  }
  public set hideOnSmallDevices(v : boolean) {
    this._hideOnSmallDevices = v;
  }
  
  
  private _routeChange : BehaviorSubject<string> = new BehaviorSubject<string>("tabs/home");

  /**
   * Triggert jedes mal wenn route in Navigation ändert
   * @returns
   */
  public routeChange() : Observable<string> {
    return this._routeChange.asObservable()
  }

  /**
   * ändert route, die subscribed werden kann
   * @param {string} route die aktuelle Route
   */
  public routeChanged(route : string) {
    this._buttons = []
    this._routeChange.next(route)
  }

  /**
   * Gibt die aktive Route zurück.
   * @returns Die aktive Route.
   */
  public get activeRoute(): string{
      return this._routeChange.value
  }
  

  
  private _breadcrumbs : FullscreenBreadcrumb[] = []
  public get breadcrumbs() : FullscreenBreadcrumb[] {
    return this._breadcrumbs;
  }
  public set breadcrumbs(v : FullscreenBreadcrumb[]) {
    this._breadcrumbs = v;
  }

  /**
   * Fügt neuen Breadcrumb der Liste hinzu
   * @param {FullscreenBreadcrumb} breadcrumb Breadcrumb welcher der Liste hinzugefüg werden soll
   */
  public addBreadcrumb(breadcrumb: FullscreenBreadcrumb){
    this._breadcrumbs.push(breadcrumb)
  }

  public hide(){
    this.isHidden = true
  }

  public show(){
    this.isHidden = false
  }

  /**
   * Führt übergebe function eines Breadcrumbs aus
   * @param {()=>void} action Function die bei Clicken ausgeführt werden soll 
   * @param {number} childIndex ab welchem Index all Breadcrumbs gelöscht werden sollen beim klicken 
   */
  public breadCrumbAction(action: () => void, childIndex: number): void{
    if(this.breadcrumbs.length  == childIndex) return
    this._buttons = []
    if(this.fullscreenSrv.isFullScreenOnTicket) this.fullscreenSrv.closeFullscreen()
    if(action) action()
    this._breadcrumbs.splice(childIndex + 1)
  }

  /**
   * geht ein Breadcrumb zurück und führt dessen Action aus
   */
  public goBack(){
    this._breadcrumbs[this._breadcrumbs.length - 2]?.action();
  }
  
  
}
